<template>
  <b-card align="left">
    <template v-slot:header>
      <b-navbar variant="faded" type="light">
        <b-container>
        <b-row>
          <b-col lg="2">
            <img src="../assets/satlogojpg.jpg" fluid class="logosCS">
          </b-col>
          <b-col lg="8">
            {{pageTitle}}
          </b-col>
          <b-col lg="2">
            <img src="../assets/logo.png" fluid class="logosCS">
          </b-col>
        </b-row>
        </b-container>
      </b-navbar>
    </template>
    <b-container>
      <b-row v-if="isActiveOperatorPanel">
        <b-col lg="1"></b-col>
        <b-col lg="10">
          <b-alert v-if="isShowAlert" variant="success" show>
            Уникальный ИД: {{result.form_id}}
          </b-alert>
          <b-alert v-if="!isShowAlert" show variant="danger">
            Уникальный ИД анкеты не создан!
          </b-alert>
        </b-col>
        <b-col lg="1"></b-col>
      </b-row>
      <b-row>
        <b-col lg="1"></b-col>
        <b-col lg="10">
          <b-alert
              v-model="showDismissibleAlert"
              variant="danger"
              dismissible>
            Вы не ответили на вопрос
            <p v-if="errorMessage">{{errorMessage}}</p>
          </b-alert>
        </b-col>
        <b-col lg="1"></b-col>
      </b-row>
      <b-row v-for="item in schemaPage" :key="item.codeQuestion">
        <b-col lg="1"></b-col>
        <form-radio
            v-if="item.typeQuestion === 'radio'"
            v-model="result"
            :answers="item.answers"
            :code-question="item.codeQuestion"
            :label="item.textQuestion"
            @action-output="actionOutput"/>

        <FormExplanation
            v-if="item.typeQuestion === 'description'"
            :title="item.titleQuestion"
            :text="item.textQuestion"/>

        <FormRadioHorisontal
            v-if="item.typeQuestion === 'radioHorizontal'"
            v-model="result"
            :code-question="item.codeQuestion"
            :comment="item.comment"
            :ranges="item.ranges"
            :label="item.textQuestion"
            @action-output="actionOutput"/>

        <FormShowTextEditorIf
            v-if="item.typeQuestion === 'textEditorDependOn'"
            v-model="result"
            :config="item"
            :schema-forms="schemaForms"
            @action-output="actionOutput"
            @skip-this-page="actionSkipPage"
        />
        <FormMultiSelect
            v-if="item.typeQuestion === 'multiSelect'"
            v-model="result"
            :answers="item.answers"
            :label="item.textQuestion"
            :code-question="item.codeQuestion"
            @action-output="actionOutput"
        />
        <FormBalanced
            v-if="item.typeQuestion === 'formBalanced'"
            v-model="result"
            :code-question="item.codeQuestion"
            :label="item.textQuestion"
            :comment="item.comment"
            :answers="item.answers"
            @action-output="actionOutput"
        />
        <FormTextEditor
            v-if="item.typeQuestion === 'textEditor'"
            :direct-value="result"
            :label="item.textQuestion"
            :code-question="item.codeQuestion"
            :rows="item.rows"
            :comment="item.comment"
            @action-output="actionOutput"
        />

        <FormExplanation
            v-if="item.typeQuestion === 'endDescription'"
            :text="item.textQuestion"
            :title="item.titleQuestion"
            v-model="result"
        />
        <b-button
            variant="primary"
            v-if="item.typeQuestion === 'btnFinish'"
            v-text="item.textQuestion"
            @click="btnFinish(item)"/>
        <b-col lg="1"></b-col>
      </b-row>
      <b-row style="margin-top: 20px">
        <b-col lg="1"></b-col>
        <b-col lg="10">
          <b-progress
              :value="currentProgress"
              :max="max"
              class="mb-3">
          </b-progress>
        </b-col>
        <b-col lg="1"></b-col>
      </b-row>
      <b-row>
        <b-col lg="4"></b-col>
        <b-col lg="4" class="pb-2">
          <b-button
              v-if="pageNumber > 0 && isLastPage()"
              variant="link"
              @click="forwardPage">
            назад</b-button>
          <b-button
              v-if="isLastPage()"
              variant="primary"
              @click="nextPage">
            дальше </b-button>
        </b-col>
        <b-col lg="4"></b-col>
      </b-row>
      <b-row v-if="schemaPage.length > 6">
        <b-col lg="1"></b-col>
        <b-col lg="10">
          <b-alert
              v-model="showDismissibleAlert"
              variant="danger"
              dismissible>
            Вы не ответили на вопрос
            <p v-if="errorMessage">{{errorMessage}}</p>
          </b-alert>
        </b-col>
        <b-col lg="1"></b-col>
      </b-row>
      <b-row>
        <b-col lg="2"></b-col>
        <b-col lg="8"></b-col>
        <b-col lg="2">
          <b-button
              variant="primary"
              v-if="isActiveOperatorPanel"
              @click="reloadPage"
          >
            Начать новую анкету
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:footer>
      <b-container  class="text-right">
        <small>© Customer Service 2020</small>
      </b-container>
    </template>
  </b-card>
</template>

<script>
import FormRadio from './form/FormRadio'
import FormRadioHorisontal from './form/FormRadioHorisontal'
import FormExplanation from './form/FormExplanation'
import FormTextEditor from './form/FormTextEditor'
import FormShowTextEditorIf from './form/FormShowTextEditorIf'
import FormMultiSelect from './form/FormMultiSelect'
import FormBalanced from './form/FormBalanced'
import _ from 'lodash'
import { v1 as uuidv1 } from 'uuid'
import RestApi from '../store/RestApi'
import DataEmployee from './DataEmployee'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

export default {
  name: 'MainPage',
  components: {
    FormRadio,
    FormRadioHorisontal,
    FormExplanation,
    FormTextEditor,
    FormShowTextEditorIf,
    FormMultiSelect,
    FormBalanced
  },
  props: {
    isActiveOperatorPanel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      result: {},
      schemaForms: [],
      schemaPage: [],
      currentProgress: 0,
      max: 100,
      pageNumber: 0,
      amountPages: 0,
      direction: '',
      directionType: {
        forward: 'forward',
        back: 'back'
      },
      formIsValid: true,
      showDismissibleAlert: false,
      errorTitle: '',
      errorMessage: '',
      clientName: 'cat',
      schemaId: 3,
      pageTitle: 'Проект: Опрос сотрудников компании САТ о качестве обслуживания'
    }
  },
  beforeMount () {
    if (!_.isUndefined(this.$route.params.formId)) {
      this.result.form_id = this.$route.params.formId
      if (!this.restoredProgress()) {
        this.result['form_id'] = uuidv1()
      }
    }
    if (!this.restoredProgress()) {
      this.result['form_id'] = uuidv1()
    }
  },
  mounted () {
    this.downloadConfigs()
    const appInsights = new ApplicationInsights({ config: {
      instrumentationKey: 'bfd9cd39-dd4e-4813-9af4-034981659590'
    } })
    appInsights.loadAppInsights()
    appInsights.trackPageView()
  },
  methods: {
    isShowAlert () {
      return this.result.form_id && this.result.form_id !== ''
    },
    getValue (code) {
      const value = this.result[code]
      console.log('getValue', value)
      return value
    },
    downloadConfigs () {
      this.schemaForms = DataEmployee.getConfig()
      this.schemaPage = this.schemaForms[0]
      this.amountPages = this.schemaForms.length
    },
    forwardPage () {
      this.formIsValid = true
      this.showDismissibleAlert = !this.formIsValid
      this.direction = this.directionType.back
      this.navigationBetweenPage()
    },
    nextPage () {
      // validation value
      this.validateValues(this.pageNumber)
      if (this.formIsValid) {
        this.direction = this.directionType.forward
        this.navigationBetweenPage()
        document.body.scrollTop = 0 // For Safari
        document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      }
    },
    validateValues (numberPage) {
      this.formIsValid = true
      this.showDismissibleAlert = !this.formIsValid
      const codeForValidate = []
      _.forEach(this.schemaPage, (item) => {
        if (item.requiredQuestion) {
          let codeQuestion = item.codeQuestion
          if (item.typeQuestion === 'textEditorDependOn') {
            codeQuestion = `${item.codeQuestion}_${item.dependsOn.codeQuestions}`
          }
          if (item.typeQuestion === 'multiSelect') {
            // codeQuestion = `${item.codeQuestion}_${}`
            _.forEach(item.answers, (node) => {
              if (this.result[node.codeQuestions] &&
                 this.result[node.codeQuestions] !== ' ') {
                codeQuestion = `${node.codeQuestions}`
              }
            })
          }
          if (item.typeQuestion === 'formBalanced') {
            this.formIsValid = this.formBalancedValidator(item.answers, item.codeQuestion)
            _.forEach(item.answers, (node) => {
              if (this.result[node.codeQuestions] &&
                this.result[node.codeQuestions] !== ' ') {
                codeQuestion = `${node.codeQuestions}`
              }
            })
          }
          console.log('codeQuestion', codeQuestion)
          codeForValidate.push(codeQuestion)
        }
      })
      if (this.formIsValid) {
        codeForValidate.forEach((code) => {
          const value = this.result[code]
          if (_.isUndefined(value) || _.isNaN(value)) {
            this.formIsValid = false
            this.showValidateMessage(code)
          }
        })
        this.showDismissibleAlert = !this.formIsValid
      } else {
        this.showDismissibleAlert = !this.formIsValid
      }
    },
    formBalancedValidator (answers, code) {
      const points = []
      _.forEach(answers, (node) => {
        if (this.result[node.codeQuestions] &&
          this.result[node.codeQuestions] !== ' ') {
          points.push(parseInt(this.result[node.codeQuestions], 10))
        }
      })
      const sum = _.sum(points)
      if (sum > 100) {
        const text = `Сумма значений: ${sum} она должна быть равна или меньше чем 100`
        this.showValidateMessage(code, text)
        return false
      } else {
        return true
      }
    },
    showValidateMessage (codeQuestion, customText) {
      this.errorMessage = ''
      const item = _.find(this.schemaPage, {codeQuestion: codeQuestion})
      if (item && item.typeQuestion !== 'textEditor') {
        this.errorMessage = _.isUndefined(customText) ? item.textQuestion : customText
      }
    },
    navigationBetweenPage () {
      if (_.isEqual(this.direction, this.directionType.forward)) {
        this.pageNumber = this.pageNumber + 1
      } else if (_.isEqual(this.direction, this.directionType.back)) {
        this.pageNumber = this.pageNumber - 1
      }
      this.schemaPage = this.schemaForms[this.pageNumber]
      this.showProgress(this.pageNumber)
    },
    reloadPage () {
      this.cleanUpProgress()
      location.reload()
    },
    isLastPage () {
      const currentPage = this.pageNumber + 1
      const isLast = this.amountPages !== currentPage
      if (!isLast) {
        this.cleanUpProgress()
      }
      return isLast
    },
    actionOutput (valObj) {
      this.result[valObj.codeQuestion] = valObj.value
      this.storedProgress()
      const answerObject = JSON.stringify(this.result)
      RestApi.RemoteStore(this.result.form_id,
        valObj.codeQuestion,
        valObj.value,
        this.clientName,
        this.schemaId,
        answerObject)
    },
    btnFinish (config) {
      const value = this.result[config.dependsOn.codeQuestions]
      console.log('value', value)
      if (!value || value.length === 0) {
        this.actionOutput({
          codeQuestion: config.dependsOn.codeQuestions,
          value: config.textQuestion
        })
      }

      this.direction = this.directionType.forward
      this.navigationBetweenPage()
    },
    actionSkipPage () {
      this.navigationBetweenPage()
    },
    showProgress (numberPage) {
      const pointPerPage = 100 / this.amountPages

      if (_.isEqual(this.direction, this.directionType.forward)) {
        this.currentProgress = pointPerPage * (numberPage + 1)
      } else {
        this.currentProgress = pointPerPage * (numberPage - 1)
      }
    },
    storedProgress () {
      const parsed = JSON.stringify(this.result)
      if (_.isUndefined(this.result.form_id)) {
        return false
      }
      const nameKey = this.result.form_id.replace(/-/g, '')
      localStorage.setItem(`forms_${nameKey}`, parsed)
    },
    restoredProgress () {
      if (_.isUndefined(this.result.form_id)) {
        return false
      }
      const nameKey = this.result.form_id.replace(/-/g, '')
      const data = localStorage.getItem(`forms_${nameKey}`)
      if (!_.isNull(data)) {
        const result = JSON.parse(data)
        this.result = result
        return true
      } else {
        return false
      }
    },
    cleanUpProgress () {
      if (_.isUndefined(this.result.form_id)) {
        localStorage.clear()
      } else {
        const nameKey = this.result.form_id.replace(/-/g, '')
        localStorage.removeItem(nameKey)
      }
    }
  }
}
</script>

<style scoped>
  .logosCS {
    max-width: 50%;
    height: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue